exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.map-privacy[data-v-8f7f96d6] {\n    background-color: rgba(255, 255, 255, 0.8);\n    width: fit-content;\n}\n", ""]);

// exports
